// routing.js — postal code -> store for the inquiry form (home-inquiry.liquid,
// main-contact.liquid), plus URL-param prefill. main-branch.liquid sets
// contact[nearest_store] server-side and does not load this script.
//
//   1. Store routing. TMG_STORE_MATCH (store-match.js, loaded by the header
//      on every page) applies the 250 km FSA rule — the same answer the
//      header's pickup flyout, the homepage band and the locator give. On
//      postal blur, a code inside a store area writes that store's town
//      ("Richmond") into the hidden nearest_store field; a code outside
//      every store area writes the field's data-outside-value ("Head
//      office"), because those leads stay with head office; text that is
//      not a postal code leaves the field alone. A recognised code is also
//      saved as the visitor's match, so the header pill follows it. Until a
//      postal code is typed, the field starts from the visitor's saved
//      match, if they made one elsewhere on the site.
//   2. URL-param prefill: `?product=<handle>` prefills the "I'm interested
//      in" select; `?store=<name>` prefills nearest_store up front, so a
//      deep link from a branch/store page or a product page arrives
//      pre-routed.
//
// Same guard + rescan() pattern as drawer.js/locator.js: window.__tmgRouting
// singleton, re-bound on `shopify:section:load`. Handlers are named
// module-scope functions passed by reference, so a rescan cannot stack
// duplicate listeners.
if (!window.__tmgRouting) {
  (function () {
    var postalInput, nearestStoreField, interestSelect;
    var paramsApplied = false;

    // ---------- 1. postal -> nearest_store ----------
    function storeValue(r) {
      if (r.store) return r.city;
      return nearestStoreField.getAttribute('data-outside-value') || '';
    }

    function onPostalBlur() {
      var M = window.TMG_STORE_MATCH;
      if (!M || !postalInput || !nearestStoreField) return;
      var r = M.match(postalInput.value);
      if (!r) return;
      nearestStoreField.value = storeValue(r);
      M.save(r);
    }

    function applySavedMatch() {
      var M = window.TMG_STORE_MATCH;
      if (!M || !nearestStoreField || nearestStoreField.value) return;
      var r = M.saved();
      if (r) nearestStoreField.value = storeValue(r);
    }

    // ---------- 2a. ?product=<handle> -> interest prefill ----------
    // Client-side because Liquid cannot read an arbitrary query parameter on
    // a page template.
    //
    // An <option> tagged `data-interest-default-product` wins if present (no
    // shipped section emits one yet). Otherwise a new <option> is appended
    // and selected, its text the handle title-cased ("1800-kg-compact-
    // excavator" -> "1800 Kg Compact Excavator"). Shopify submits whatever
    // text the option carries as contact[interest].
    function prettifyHandle(handle) {
      return handle
        .replace(/-/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/\S+/g, function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        });
    }

    function applyProductParam(handle) {
      if (!interestSelect || !handle) return;
      var preset = interestSelect.querySelector('[data-interest-default-product]');
      if (preset) {
        preset.selected = true;
        return;
      }
      // Remove any existing prefilled option (for theme-editor re-renders)
      var existing = interestSelect.querySelector('[data-tmg-product-prefill]');
      if (existing) {
        existing.remove();
      }
      var opt = document.createElement('option');
      opt.textContent = prettifyHandle(handle);
      opt.selected = true;
      opt.setAttribute('data-tmg-product-prefill', '');
      interestSelect.appendChild(opt);
    }

    // ---------- 2b. ?store=<name> -> nearest_store prefill ----------
    // URLSearchParams#get already decodes percent-escapes and `+`.
    //
    // Sets the hidden field directly, before the visitor has typed anything.
    // It wins over the saved match (applySavedMatch only fills an empty
    // field), and a postal code the visitor then types wins over it: the
    // blur handler above overwrites the field for any recognised code.
    function applyStoreParam(name) {
      if (!nearestStoreField || !name) return;
      nearestStoreField.value = name;
    }

    // ---------- bind / rescan ----------
    function bind() {
      postalInput = document.querySelector('[data-postal-code-input]');
      nearestStoreField = document.querySelector('[data-nearest-store-field]');
      interestSelect = document.querySelector('select[name="contact[interest]"]');

      if (postalInput && nearestStoreField) {
        postalInput.addEventListener('blur', onPostalBlur);
      }
    }

    function rescan() {
      bind();
    }

    document.addEventListener('shopify:section:load', function () {
      window.__tmgRouting.rescan();
    });

    bind();

    // URL params apply once, not on rescans. Missing params or targets are
    // no-ops. The saved match goes last so a ?store= deep link keeps
    // priority over it.
    if (!paramsApplied) {
      var params = new URLSearchParams(window.location.search);
      applyProductParam(params.get('product'));
      applyStoreParam(params.get('store'));
      applySavedMatch();
      paramsApplied = true;
    }

    window.__tmgRouting = { rescan: rescan };
  })();
}
